export default {
  setCursorX (state, cursor_x) {
    state.cursor_x = cursor_x
  }
}
